module.exports = __webpack_public_path__ + "media/images/countryrect/az-e6492744b42cd345c84d212bd20e32dc.svg";